
const baseUrl = process.env.REACT_APP_API_URL;

export const userBaseUrl = baseUrl;
export const uploadBaseUrl = baseUrl;
export const mastersBaseUrl = baseUrl;
export const productsBaseUrl = baseUrl;
export const advanceSearchBaseUrl = baseUrl;
